// Axios instance and types
import http from '../api'
import { APIResponse, Filters, APIPaginatedResponse, Pagination } from '../types'
import { TypeCreateServicePointUnit, TypeServicePointUnit } from './types'
import { getRequestParamString } from '../utils/utils'

const apiPath = import.meta.env.VITE_API_PATH

async function getServicePointUnits(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<any>>(
    apiPath + 'service-point/unit' + getRequestParamString(filters, pagination),
  )
}

async function deleteServicePointUnit(servicePointUnitId: number) {
  return await http.delete<APIResponse<boolean>>(`${apiPath}service-point/unit/${servicePointUnitId}`)
}

async function createServicePointUnit(input: TypeCreateServicePointUnit) {
  const payLoad = {
    name: input.name,
    description: input.description,
  }
  return await http.post<APIResponse<any>>(apiPath + 'service-point/unit', payLoad)
}

async function updateServicePointUnit(input: TypeServicePointUnit) {
  const payLoad = {
    name: input.name,
    description: input.description,
  }
  return await http.patch<APIResponse<boolean>>(`${apiPath}service-point/unit/${input.id}`, payLoad)
}

async function getUnitOfServicePointId(servicePointId: number) {
  return await http.get<APIPaginatedResponse<any>>(apiPath + 'service-point/unit/' + servicePointId)
}

export default {
  getServicePointUnits,
  deleteServicePointUnit,
  createServicePointUnit,
  updateServicePointUnit,
  getUnitOfServicePointId,
}
